module.exports = __webpack_public_path__ + "media/npc_dota_hero_necrolyte.59aad6a3.webm";